import { useEffect, useState } from 'react';
import { Link } from 'react-scroll'
import { Avatar, Box, Button, useMediaQuery } from '@mui/material'
import { Close } from '@mui/icons-material';
import { ArrowDown, ToolCategoryIcons } from '../../../../../core/global/Icons';
import { ToolCategories } from '../../../toolcategories/Index';
import biz from '../../../../../assets/images/logos/biz_logo.png'
import pofsis from '../../../../../assets/images/logos/pofsis2.png'

export const Desktop = ({divID, navFeature, open, setOpen, registration, login, redirectHandler, handleClickContactUs, HandleClickTC}) => {
    const desktopsm = useMediaQuery('(max-width:1145px)');
    const [lastScrollY, setLastScrollY] = useState(0);
    const [scrollDirection, setscrollDirection] = useState(0);
  
    const handleScrollEvent = () => {
        const currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY) {
            setscrollDirection('down');
        } else if(lastScrollY >= currentScrollY){
            setscrollDirection('up');
        }
        setLastScrollY(currentScrollY);
    };
  
    useEffect(() => {
        window.addEventListener('scroll', handleScrollEvent);
    
        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastScrollY]);

    return (
        <Box minHeight={scrollDirection === 'down' ? '80px' : "167px"} width="100%" display="flex" flexDirection="column" sx={{position: 'fixed', zIndex:1200}}>
            <Box height="87px" width="100%" bgcolor="#002016" display={scrollDirection === 'down' ? 'none' : "flex"} justifyContent="center" gap="12px">
                <Box component={Button} fontSize="16px" fontWeight={400} sx={{p:'44px 40px 24px 40px', color: '#ACC6B1'}} onClick={redirectHandler}>Personal</Box>
                <Box component={Button} fontSize="16px" fontWeight={600} borderBottom='2px solid #DCFFF1' sx={{p:'44px 40px 24px 40px', color: '#DAE8DA'}}>Business</Box>
            </Box>
            <Box height="80px" width="100%" bgcolor="#003022" display="flex" justifyContent="space-between" alignItems="center">
                <Box height="100%" minWidth="80px" bgcolor="#003F2E" display="flex" justifyContent="center" alignItems="center">
                    <Avatar src={pofsis} variant='square' sx={{height:'40px', width:'26px'}}/>
                </Box>
                <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center" gap={{xs:'12px', xl:'142px'}}>
                    <Box height="100%" display="flex" alignItems="center" gap={{xs:'12px', xl:'32px'}}>
                        <Box onClick={()=>handleClickContactUs('home')} display="flex" alignItems="center" className="c-pointer" gap="12px">
                            <Avatar src={biz} variant='square' sx={{height:'28px', width:'28px'}}/>
                            <Box color="#DAE8DA" fontSize="22px" fontWeight={600}>Business</Box>
                        </Box>
                        <Box onClick={HandleClickTC} component={Button} disableRipple height="100%" width="130px" display="flex" alignItems="center" gap="12px" sx={{':hover': {bgcolor: '#003F2E'}}}>
                            <ToolCategoryIcons/>
                            <Box display="flex" alignItems="center" gap="10px">
                                <Box color="#DCFFF1" fontSize="16px" fontWeight={600}>Tools</Box>
                                {open?  <Close sx={{color:'#ffffff', height:20, width:20}} />: <ArrowDown/>}
                            </Box>
                        </Box>
                    </Box>
                    <Box height="100%" display="flex" justifyContent="center" alignItems="center" gap={desktopsm ? '8px' : '56px'}>
                        <Box display="flex" justifyContent="center" alignItems="center" gap={desktopsm ? '8px':'12px'}>
                            {navFeature.map((v,k) => (
                                <Link onClick={()=>handleClickContactUs(v.to)} offset={v.to !== 'home' ? -80 : -168} key={k} to={v.to} smooth={true} duration={500} className={`c-pointer call-${v.to}`} >
                                    <Box color={"#DCFFF1"} fontSize={desktopsm ? 14 : 16} fontWeight={divID === v.to ? 600 : 400} lineHeight={divID === v.to ? '23px' : '24px'}>{v.name}</Box>
                                </Link>
                            ))}
                        </Box>
                        <Box display="flex" justifyContent="center" alignItems="center" gap={desktopsm ?'10px' : '16px'}>
                            <Button onClick={registration} variant="contained" color="primary" sx={{color: '#FFFFFF', fontSize: '16px', fontWeight: '600', borderRadius: '6px', width:'160px', height:'48px'}}>Try It For Free!</Button>
                            <Box onClick={login} component={Button} sx={{color: '#FFFFFF', fontSize: '16px', fontWeight: '600', borderRadius: '6px', width:'101px', height:'48px'}}>Sign in</Box>
                        </Box>
                    </Box>
                </Box>
                <Box height="100%" minWidth={{xs:'0px', xl:'80px'}}></Box>
            </Box>
            {open && (
                <ToolCategories divID={divID} navFeature={navFeature} open={open} setOpen={setOpen}/>
            )}
        </Box>
    )
}